import * as ActionType from "./auditLog.type";
import { apiInstanceFetch } from "../../../util/api";

export const getAuditLogs = (params = {}) => (dispatch) => {
  const q = new URLSearchParams();
  q.append("limit", params.limit || 50);
  q.append("start", params.start || 1);
  if (params.outcome) q.append("outcome", params.outcome);
  if (params.search) q.append("search", params.search);

  apiInstanceFetch
    .get(`auditLog/all?${q.toString()}`)
    .then((res) => {
      dispatch({
        type: ActionType.GET_AUDIT_LOGS,
        payload: { data: res.data || [], total: res.total || 0 },
      });
    })
    .catch((error) => console.error(error));
};

export const getAuditStats = () => (dispatch) => {
  apiInstanceFetch
    .get(`auditLog/stats`)
    .then((res) => {
      dispatch({ type: ActionType.GET_AUDIT_STATS, payload: res.data || {} });
    })
    .catch((error) => console.error(error));
};

export const getCoinLeaderboard = (params = {}) => (dispatch) => {
  const q = new URLSearchParams();
  q.append("limit", params.limit || 100);
  q.append("start", params.start || 1);
  if (params.search) q.append("search", params.search);

  apiInstanceFetch
    .get(`auditLog/leaderboard?${q.toString()}`)
    .then((res) => {
      dispatch({
        type: ActionType.GET_COIN_LEADERBOARD,
        payload: { data: res.data || [], total: res.total || 0 },
      });
    })
    .catch((error) => console.error(error));
};
